<template>
  <div>
    <ActionsMenu
      ref="actionMenu"
      :actions="actions"
      @edit="toggleEdit"
      @archive="handleArchive"
      @unarchive="handleUnarchive"
      @history="toggleHistory"
    />
    <TimeCardModal v-if="editModal" :time-card="timeCard" @close="toggleEdit" />
    <TimeCardHistoryModal
      v-if="historyModal"
      :time-card="timeCard"
      @close="toggleHistory"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import { EventBus } from "@/lib/event_bus";
import { useStore } from "vuex";

import { TimeCard } from "@/typings/timeCard";
import TimeCardHistoryModal from "./TimeCardHistoryModal.vue";
import TimeCardModal from "./TimeCardModal.vue";

const store = useStore();
const props = defineProps<{ timeCard: TimeCard }>();
const editModal = ref(false);
const historyModal = ref(false);

const actions = computed(() => {
  return [
    {
      label: "Edit Time",
      icon: "far fa-pen-to-square",
      eventName: "edit"
    },
    {
      label: "Notes",
      icon: "far fa-rectangle-history-circle-plus",
      eventName: "history"
    },
    {
      label: "Archive",
      icon: "far fa-box-archive",
      eventName: "archive",
      visible: props.timeCard.archived_at === null
    },
    {
      label: "Unarchive",
      icon: "far fa-box-archive",
      eventName: "unarchive",
      visible: props.timeCard.archived_at !== null
    }
  ];
});

function toggleEdit() {
  // sets edit id and passes all prop to timecard modal
  editModal.value = !editModal.value;
}

async function handleArchive() {
  try {
    await store.dispatch("archiveTimeCard", props.timeCard);
    window.notify.success("Time Card archived successfully!");
    EventBus.$emit("refresh-datatable");
  } catch (e) {
    console.error(e);
  }
}

async function handleUnarchive() {
  try {
    await store.dispatch("unarchiveTimeCard", props.timeCard);
    window.notify.success("Time Card unarchived successfully!");
    EventBus.$emit("refresh-datatable");
  } catch (e) {
    console.error(e);
  }
}
function toggleHistory() {
  // Opens a timecardscommentsmodal component and passes id
  historyModal.value = !historyModal.value;
}
</script>

<style scoped></style>
